import { render } from "./showMailPanel.vue?vue&type=template&id=e1249d0c&scoped=true"
import script from "./showMailPanel.vue?vue&type=script&lang=js"
export * from "./showMailPanel.vue?vue&type=script&lang=js"

import "./showMailPanel.vue?vue&type=style&index=0&id=e1249d0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1249d0c"]])

export default __exports__